import React from "react";
import { TextInput } from "pureUi/TextInput";
import { SvgIcon } from "ui/SvgIcon";
import MagnifyingIcon from 'ui/Icons/magnifying-glass.component.svg';
import { theme } from "../../../../tailwind.config";
import { LHPChat } from "./LHPChat";
import { IChat } from "..";
import { IToEditProps } from "../hooks/useChatState";
import { Conversation } from "services/ChatApi";
import CircleCloseIcon from "ui/Icons/circleClose.component.svg";
import classNames from "classnames";
import { LoadingBar } from "ui/NetworkStatusBar";

export interface ILeftHandPanel {
  handleSelectChat: (chatId: string) => void;
  pinChat: (pin: boolean, conversationId: string) => void;
  selectChatToDelete: (conversationId: string) => void;
  handleEditChatName: (newName: string) => void;
  handleSetChatToEdit: (editObj: IToEditProps | null) => void
  renameChat: () => void;
  setSearchQuery: (query: string) => void;
  chats: IChat[];
  pinnedChats: IChat[];
  selectedChat: string | null | undefined;
  editingChatName: IToEditProps | null;
  searchQuery: string;
  isLoadingChats: boolean
}

export const LeftHandPanel = (props: ILeftHandPanel) => {
  const {
    selectedChat,
    chats,
    pinnedChats,
    editingChatName,
    searchQuery,
    isLoadingChats,
    selectChatToDelete,
    pinChat,
    handleEditChatName,
    handleSetChatToEdit,
    renameChat,
    handleSelectChat,
    setSearchQuery,
  } = props;

  const circleCloseIconClassname = classNames('absolute fill-brown-80 hover:fill-brown-120 absolute w-[18px] top-[11px] right-[10px]', {
    'hidden': searchQuery === '',
  });
  
  return (
    <div className="chat-history min-w-[320px] h-full border border-gray-40 rounded-[4px] p-20px flex flex-col">
      <h4 className="text-17px font-bold mt-0 mb-10px">Chat History</h4>
      <TextInput
        className="flex flex-col relative mb-20px"
        placeholder="Search Chats..."
        inputClassName="bg-white-hard !px-[35px] placeholder:!text-gray-80 placeholder:italic placeholder:text-15px placeholder:!capitalize"
        id="chat-search"
        value={searchQuery}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSearchQuery(e.target.value)}
        autoComplete="off"
      >
        <CircleCloseIcon onClick={() => setSearchQuery('')} className={circleCloseIconClassname} />
        <SvgIcon
          className="searchIcon absolute w-[18px] top-[6px] left-[10px] rotate-90"
          width="20"
          height="20"
          IconComponent={MagnifyingIcon}
          defaultFill={theme.colors['gray-60']}
        />
      </TextInput>
      {chats.length === 0 && pinnedChats.length === 0 && !isLoadingChats ?
        (
          <div className="italic text-15px ">No Chats Found.</div>
        ) : (
          isLoadingChats ?
            (
              <div className="container w-full min-w-full mx-auto">
                <LoadingBar label="Loading content..." />
              </div>
            ) :
            (
              <div className="flex flex-col gap-20px overflow-y-auto">
                {pinnedChats.length > 0 && (
                  <div className="pinned-chats flex flex-col gap-5px">
                    <h4 className="text-12px text-gray-100 font-light font-pt-sans m-0">PINNED CHATS</h4>
                    {pinnedChats.map(chat => (
                      <LHPChat
                        chatName={chat.name}
                        chatTimeStamp={chat.timestamp}
                        isSelected={!!selectedChat && selectedChat === chat.conversationId}
                        chatId={chat.conversationId}
                        editingChatName={editingChatName}
                        isPinned={true}
                        handleSelect={handleSelectChat}
                        pinChat={pinChat}
                        selectChatToDelete={selectChatToDelete}
                        handleEditChatName={handleEditChatName}
                        handleSetChatToEdit={handleSetChatToEdit}
                        renameChat={renameChat}
                      />
                    ))}
                  </div>
                )}
                {chats.length > 0 && (
                  <div className="recent-chats flex flex-col gap-5px">
                    <h4 className="text-12px text-gray-100 font-light font-pt-sans m-0">RECENT CHATS</h4>
                    {chats.map(chat => (
                      <LHPChat
                        chatName={chat.name}
                        chatTimeStamp={chat.timestamp}
                        isSelected={!!selectedChat && selectedChat === chat.conversationId}
                        chatId={chat.conversationId}
                        isPinned={false}
                        editingChatName={editingChatName}
                        pinChat={pinChat}
                        selectChatToDelete={selectChatToDelete}
                        handleEditChatName={handleEditChatName}
                        handleSetChatToEdit={handleSetChatToEdit}
                        handleSelect={handleSelectChat}
                        renameChat={renameChat}
                      />
                    ))}
                  </div>
                )}
              </div>
            )
        )
      }
    </div>
  );
};